<template>
    <v-dialog v-model="showModal" v-if="showModal" max-width="1000px" persistent>
        <v-card>
            <v-toolbar dark class="primary">
                <v-btn icon @click.native="showModal = false" dark>
                    <v-icon>fa-times</v-icon>
                </v-btn>
                <v-toolbar-title>{{title}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-form :class="visibility_class" @submit="handleSubmit">
                    <v-tabs
                            grow
                            v-model="active_tab"
                            slider-color="primary"
                    >
                        <v-tab ripple key="0">Ogólne</v-tab>
                        <v-tab ripple key="1">Dane adresowe</v-tab>
                        <v-tab ripple key="2">Dane firmy</v-tab>
                        <v-tab ripple key="3">Zgody</v-tab>
                        <v-tab-item key="0">
                            <v-card flat>
                                <v-card-text>
                                    <v-container>
                                        <v-row align-content="start">
                                            <v-col cols="6">
                                                <v-text-field label="Imię*" v-validate="'required'" name="firstName" id="firstName"  data-vv-as="Imię"
                                                              :error-messages="errors.collect('firstName')" v-model="firstName"></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field label="Nazwisko*" v-validate="'required'" name="lastName" id="lastName"  data-vv-as="Nazwisko"
                                                              :error-messages="errors.collect('lastName')" v-model="lastName"></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field label="Adres email" name="emailAddress" id="emailAddress" v-model="emailAddress" v-validate="'email'" data-vv-as="Adres email" :error-messages="errors.collect('emailAddress')"></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                    <v-row no-gutters>
                                                        <v-col cols="8">
                                                            <v-text-field label="Telefon" v-validate="{regex:/^[0-9\+]{8,13}$/}" name="telephone" id="telephone"
                                                                          :error-messages="errors.collect('telephone')" data-vv-as="Telefon" v-model="telephone"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-checkbox
                                                                    name="telephoneForSMS" id="telephoneForSMS"
                                                                    v-model="telephoneForSMS"
                                                                    label="Do smsów?"
                                                            ></v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field label="Numer PESEL" name="pesel" id="pesel"  data-vv-as="Numer PESEL"
                                                              v-validate="{regex:/^[0-9]{11}$/}"
                                                              :error-messages="errors.collect('pesel')" v-model="pesel"></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field label="NIP" name="nip" id="nip"  data-vv-as="Numer NIP"
                                                              v-validate="{regex:/^[0-9]{10}$/}"
                                                              :error-messages="errors.collect('nip')" v-model="nip"></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-select :items="genders" clearable label="Płeć" placeholder="Wybierz płeć.." v-model="gender" name="gender" id="gender">
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-textarea
                                                        name="notes"
                                                        label="Uwagi"
                                                        outline
                                                        v-model="notes"
                                                        id="notes"
                                                ></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item key="1">
                            <v-card flat>
                                <v-card-text>
                                    <v-container>
                                        <v-row align-content="start">
                                            <v-col cols="6">
                                                <v-text-field label="Ulica" name="street" id="street" v-model="street"></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field label="Kod pocztowy" name="postcode" id="postcode" v-model="postcode"></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field label="Miasto" name="city" id="city" v-model="city"></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-autocomplete label="Kraj" :items="countries" v-model="country"></v-autocomplete>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item key="2">
                            <v-card flat>
                                <v-card-text>
                                    <v-container>
                                        <v-row align-content="start">

                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item key="3">
                            <v-card flat>
                                <v-card-text>
                                    <v-container>
                                        <v-row align-content="start">

                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="closeForm" color="error">Zamknij</v-btn>
                <v-btn color="success" @click="handleSubmit">Zapisz</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import swal from "sweetalert";
    import {countriesList} from "../../helpers/countries";

    export default {
        name: "AddEditTrainee",
        data() {
          return {
              title: "Dodawanie nowego kursanta",
              loading: false,
              active_tab: 0,
              visibility_class: 'row',
              firstName: null,
              lastName: null,
              emailAddress: null,
              telephone: null,
              telephoneForSMS: false,
              pesel: null,
              nip: null,
              street: null,
              postcode: null,
              city:null,
              country: null,
              genders: [
                  { value: 0, text: "Mężczyzna" },
                  { value: 1, text: "Kobieta" },
              ],
              notes: null,
              countries: countriesList
          }
        },
        computed: {
            showModal: {
                get: function() {
                    return this.visible
                },
                set: function(value) {
                    if(!value){
                        this.$emit('close')
                    }

                }
            }
        },
        methods: {
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            },
            closeForm() {
                this.$emit("close");
            },
            handleSubmit() {
            },
            hide() {
                this.visibility_class = 'row scale-transition scale-out'
                this.loading = true
            },
            show() {
                this.visibility_class = 'row'
                this.loading = false
            },
        },
        props: ["id","visible"]
    }
</script>

<style>

</style>